import React, { createContext, useContext, useEffect, useState } from 'react';
import io from 'socket.io-client';
import { useAuth } from '../hooks/useAuth';

const SocketContext = createContext();

export const useSocket = () => useContext(SocketContext);

export const SocketProvider = ({ children }) => {
    const { user } = useAuth();
    const token = localStorage.getItem('token');
    const [socket, setSocket] = useState(null);
    const [unreadCount, setUnreadCount] = useState(0);

    useEffect(() => {
        if (!user || !token) return;

        // Determinar URL do Socket dinamicamente
        let SOCKET_URL = process.env.REACT_APP_API_URL;

        // Se não houver variável definida, usar a origem atual (para produção/container único)
        if (!SOCKET_URL) {
            SOCKET_URL = window.location.origin;
        }

        // Em desenvolvimento local, se window.location for localhost:7050, forçar backend 7065
        if (window.location.hostname === 'localhost' && window.location.port === '7050') {
            SOCKET_URL = 'http://localhost:7065';
        }

        const newSocket = io(SOCKET_URL, {
            path: '/socket.io/', // Caminho padrão explícito
            transports: ['polling', 'websocket'], // Forçar transportes para evitar upgrade prematuro falho
            auth: {
                token,
                nome: user.nome_completo || user.st_nome
            },
            query: { token }
        });

        setSocket(newSocket);

        newSocket.on('receive_message', (msg) => {
            // Se mensagem for recebida (não enviada por mim) e não estivermos no chat
            // (A verificação de path é simples, idealmente o ChatComponent zera ao focar)
            if (window.location.pathname !== '/chat') {
                setUnreadCount(prev => prev + 1);
                // Opcional: Tocar som
            }
        });

        return () => newSocket.close();
    }, [user, token]);

    const resetUnread = () => setUnreadCount(0);

    return (
        <SocketContext.Provider value={{ socket, unreadCount, resetUnread }}>
            {children}
        </SocketContext.Provider>
    );
};
